import { createContext } from 'react';

const FullScreenContext = createContext();

export default FullScreenContext;
